module.exports = __webpack_public_path__ + "img/versendet_gruen8.373980e5.png";